import React, { useEffect, useState } from 'react';

const offers = [
    {
    id: 'o2',
    title: 'تخفیف ویژه به دلیل آلودگی هوا',
    description: 'برنامه تمرین در منزل فقط ۵۰،۰۰۰ تومان',
    code: 'o2',
    bg: 'from-gray-900 via-green-700 to-gray-900',
    border: 'border-green-500',
  },
  {
    id: 'st01',
    title: 'خرید اول پلن عادی',
    description: '۱۵۰،۰۰۰ تومان تخفیف برای اولین خرید پلن عادی',
    code: 'st01',
    bg: 'from-blue-900 via-blue-700 to-blue-900',
    border: 'border-blue-500',
  },
  {
    id: 'pr01',
    title: 'خرید اول پلن پرمیوم',
    description: '۲۵۰،۰۰۰ تومان تخفیف برای اولین خرید پلن پرمیوم',
    code: 'pr01',
    bg: 'from-purple-900 via-purple-700 to-purple-900',
    border: 'border-purple-500',
  },
];

export default function DiscountStrip() {
  const [current, setCurrent] = useState(0);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    if (!visible || offers.length <= 1) return;

    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % offers.length);
    }, 6000);

    return () => clearInterval(timer);
  }, [visible]);

  if (!visible || offers.length === 0) return null;

  const offer = offers[current];

  return (
    <div
      className={`
        sticky top-0 z-50 
        bg-gradient-to-r ${offer.bg}
        text-white text-center 
        py-2 px-3
        shadow-md 
        ${offer.border} border-b
      `}
    >
      <div className="max-w-5xl mx-auto flex items-center justify-between gap-2 text-xs sm:text-sm">
        {/* متن تخفیف */}
        <div className="flex-1 flex flex-col sm:flex-row sm:items-center sm:justify-center gap-1 sm:gap-2">
          <span className="hidden sm:inline">🎁</span>
          <span className="font-bold">{offer.title}</span>
          <span className="sm:inline text-[0.7rem] sm:text-xs md:text-sm">
            {offer.description}
          </span>
          <span className="hidden sm:inline">|</span>
          <span className="sm:inline">
            کد:
<span 
  className="text-black-300 font-extrabold mx-1 tracking-widest"
  dir="ltr"
>
              {offer.code}
            </span>
          </span>
        </div>

        {/* دات‌ها */}
        {offers.length > 1 && (
          <div className="flex items-center gap-1 mx-2">
            {offers.map((o, idx) => (
              <button
                key={o.id}
                onClick={() => setCurrent(idx)}
                className={`w-1.5 h-1.5 rounded-full ${
                  idx === current ? 'bg-white' : 'bg-white/40'
                }`}
              />
            ))}
          </div>
        )}

        {/* دکمه بستن
        <button
          onClick={() => setVisible(false)}
          className="text-white/80 hover:text-white text-lg leading-none px-1"
          aria-label="بستن"
        >
          ×
        </button> */}
      </div>
    </div>
  );
}
